/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated';
import { UnitDependencies } from './dependenciesUnitClass.generated';
import { createProtonMass } from '../../factoriesAny.js';
export var protonMassDependencies = {
  BigNumberDependencies: BigNumberDependencies,
  UnitDependencies: UnitDependencies,
  createProtonMass: createProtonMass
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesProtonMass.generated.js
// module id = 1621
// module chunks = 0